// HOAD: setas do carrossel de Embaixadores — mesmo padrão do
// hoad-video-carousel.js (scroll-snap nativo do CSS cuida do arrasto,
// isso só calcula quanto rolar por clique e esconde a seta na ponta).
(function () {
  function setup(root) {
    var track = root.querySelector('[data-hoad-ambassadors-track]');
    var cards = root.querySelectorAll('.hoad-ambassadors__card');
    var prevBtn = root.querySelector('[data-hoad-ambassadors-prev]');
    var nextBtn = root.querySelector('[data-hoad-ambassadors-next]');

    if (!track || !cards.length) return;

    function scrollByOneCard(direction) {
      var card = cards[0];
      var gap = 20;
      var amount = (card.getBoundingClientRect().width + gap) * direction;
      track.scrollBy({ left: amount, behavior: 'smooth' });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollByOneCard(-1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollByOneCard(1);
      });
    }

    function updateNavVisibility() {
      if (!prevBtn || !nextBtn) return;
      var atStart = track.scrollLeft <= 4;
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      prevBtn.hidden = atStart;
      nextBtn.hidden = atEnd;
    }

    track.addEventListener('scroll', updateNavVisibility, { passive: true });
    window.addEventListener('resize', updateNavVisibility);
    updateNavVisibility();
  }

  document.querySelectorAll('[data-hoad-ambassadors-carousel]').forEach(setup);
})();
